// extracted by mini-css-extract-plugin
module.exports = {"preview":"InlineHtmlPreview_preview__s2BAR","viewport":"InlineHtmlPreview_viewport__TKlIM","frame":"InlineHtmlPreview_frame__bRJFZ","status":"InlineHtmlPreview_status__xWDXf"};